export default __webpack_public_path__ + "bitbucket-logotype-camera-lens-in-perspective.png";